import { useState } from "react";
import { filmAdaptations, tvAdaptations } from "@/mocks/adaptations";
import SectionHeading from "./SectionHeading";

const tabs = [
  { id: "film", label: "电影方向", icon: "ri-film-line" },
  { id: "tv", label: "电视剧方向", icon: "ri-tv-2-line" },
];

export default function AdaptationsSection() {
  const [active, setActive] = useState("film");
  const list = active === "film" ? filmAdaptations : tvAdaptations;

  return (
    <section id="adaptations" className="section-anchor w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-24">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
            <SectionHeading
              eyebrow="题材影视剧"
              title="潘金莲题材影视剧的两个主要方向"
              desc="电影方向偏向在有限时长内集中讲好一段人物故事；电视剧方向则以更长篇幅容纳群像与支线。切换标签即可对照两个方向的内容。"
            />

            <div
              role="tablist"
              aria-label="题材影视剧方向切换"
              className="inline-flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200/70 self-start lg:self-auto"
            >
              {tabs.map((t) => (
                <button
                  key={t.id}
                  type="button"
                  role="tab"
                  aria-selected={active === t.id}
                  onClick={() => setActive(t.id)}
                  className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
                    active === t.id
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:bg-background-200/70"
                  }`}
                >
                  <i className={t.icon}></i>
                  {t.label}
                </button>
              ))}
            </div>
          </div>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
            {list.map((item) => (
              <article
                key={item.id}
                className="rounded-lg bg-background-50 border border-background-200/70 p-6 flex flex-col"
              >
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <span className="shrink-0 px-3 py-1 rounded-full text-xs bg-accent-100 text-accent-900 whitespace-nowrap">
                    {item.era}
                  </span>
                </div>
                <p className="mt-2 text-xs font-label tracking-wide text-secondary-700">
                  {item.meta}
                </p>
                <p className="mt-4 text-sm leading-relaxed text-foreground-700 flex-1">
                  {item.desc}
                </p>
              </article>
            ))}
          </div>

          <p className="mt-6 text-xs md:text-sm text-foreground-500 leading-relaxed">
            说明：以上为题材方向的整理与索引，条目以方向性描述为主；具体片名、年份与主创可能因版本和发行地区不同而有所差异。
          </p>
        </div>
      </div>
    </section>
  );
}